import script from "./workPage.vue?vue&type=script&setup=true&lang=js"
export * from "./workPage.vue?vue&type=script&setup=true&lang=js"

import "./workPage.vue?vue&type=style&index=0&id=82ba0cd0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82ba0cd0"]])

export default __exports__